import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { Size } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import { UserUtils, EnvironmentUtils } from 'utils'
import useLazySelector from 'hooks/useLazySelector'
import {
  BranchWrapper,
  Title,
  Wrapper as NavItemWrapper,
} from 'components/navigation/NavTree/NavTree.styled'
import { AccountTypes } from 'modules/Auth/types'
import programBuilderRoutes from 'modules/programBuilder/routes'
import { NavTreeSection } from './Sidebar.styled'

const { Typography, skeletonStyles } = common
const { ContentTrace, Translucent } = skeletonStyles

const ProgramBuilderMenuItem = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { programBuilderAvailable } = EnvironmentUtils.getPermissions('selfServiceConfiguration')
  const { type } = UserUtils.getUserAccountInfo()
  const isSpecialUser = type === AccountTypes.SpecialUser
  const { isLoading, isOffice } = useLazySelector(({ system }) => {
    const { isLoading, result } = system.customerInformation
    return {
      isLoading,
      isOffice: result?.information?.currentInstallation?.isOffice,
    }
  })

  if (isLoading)
    return (
      <Translucent opacity='0.7'>
        <NavTreeSection>
          <NavItemWrapper>
            <BranchWrapper>
              <Title>
                <ContentTrace size={Size.Small} width='100%' color='oceanDark' />
              </Title>
            </BranchWrapper>
          </NavItemWrapper>
        </NavTreeSection>
      </Translucent>
    )

  if (isSpecialUser && programBuilderAvailable && isOffice)
    return (
      <NavTreeSection>
        <NavItemWrapper>
          <BranchWrapper>
            <Title>
              <Typography
                variant='small'
                onClick={() => dispatch(push(programBuilderRoutes.root))}
                title={t('navigation.programs')}
              >
                {t('navigation.programs')}
              </Typography>
            </Title>
          </BranchWrapper>
        </NavItemWrapper>
      </NavTreeSection>
    )
  return null
}

export default ProgramBuilderMenuItem
